import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'react-i18next';

import './styles.scss';
import StyledLink from '../StyledLink';
import PrimaryButton from '../PrimaryButton';
import { openInNewTab } from '../../pages/WelcomePage/helpers/cards';

const HelperCard = ({ card, type, buttonText }) => {
  const { t, i18n } = useTranslation();

  const isDarkMode =
    window.matchMedia('(prefers-color-scheme: dark)').matches || window.matchMedia('(color-scheme: dark)').matches;

  const usedLang = i18n.language;
  return (
    <div className={`card-wrappers ${isDarkMode ? 'wrappers-dark' : 'wrappers-light'}`}>
      <img
        src={card.img}
        alt="Card"
        className={`card-images ${type === 'applications' ? 'card-image-applications' : ''}`}
      />
      <div
        className={`card-contents ${type === 'applications' ? 'card-content-applications' : 'card-content-tutorials'}`}
      >
        <h2 className="card-title">{t(card.title)}</h2>
        <div className="card-text-wrapper">
          <p className="card-text">{t(card.text)}</p>
        </div>
        <div className="content-wrappers">
          {type === 'applications' && (
            <div className="card-link-wrapper">
              {card.information && (
                <StyledLink href={card.information[usedLang]} target="_blank" rel="noopener noreferrer">
                  {t('coursesPage.moreInfoLink')}
                </StyledLink>
              )}
            </div>
          )}
          {card.link && (
            <PrimaryButton onClick={() => openInNewTab(card.link[usedLang] || card.link)} className="mb-0">
              {t(buttonText)}
            </PrimaryButton>
          )}
          {card.downloadButtons && (
            <div className="downloads-button-wrapper">
              {card.downloadButtons.map(button => (
                <img
                  className="download-button"
                  key={uuidv4()}
                  src={button.img}
                  alt={button.text}
                  onClick={() => openInNewTab(button.link)}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HelperCard;
